import formApi from '@/services/form/formApi'

const state = {
    forms: [],
}

const getters = {}

const mutations = {
    SET_FORMS(state, forms) {
        state.forms = forms
    },
}

const actions = {
    async fetchForms({ commit }, q) {
        const forms = await formApi.fetchForms(q)
        commit('SET_FORMS', forms)   // commit ก่อน return
        return forms
    },

    requestDownload(_ctx, id) {
        return formApi.requestDownload(id)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
